import { Directive, OnInit, Input, ElementRef } from '@angular/core'
import { AngularFireStorage } from 'angularfire2/storage'

@Directive({
  selector: '[appBackground]'
})
export class BackgroundDirective implements OnInit {

  @Input() appBackground: string

  constructor(public el: ElementRef, private storage: AngularFireStorage) {}

  ngOnInit () {
    this.storage
    .ref(this.appBackground)
    .getDownloadURL()
    .subscribe(
      res => this.el.nativeElement.style.backgroundImage = 'url(' + res + ')'
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/background.directive.ts